import Logo3ET from "app/components/Logos/Logo3ET";
import logo from "app/images/banners/welcome-banner.webp";
import "./WelcomeBanner.scss";

const WelcomeBanner = () => {
  return (
    <div className="form-details__row welcome-banner">
      <img
        className="option__nuvei-logo"
        width="632"
        height="196"
        src={logo}
        alt="welcome banner"
      />
      <Logo3ET />
    </div>
  );
};

export default WelcomeBanner;
